<div class="message message-warning" data-testid="<%= testIds.booking.error %>">
  <%- error_messages.base_epic_make_fail_error %>
</div>
